import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Carousel, Col, Collapse, Row } from 'react-bootstrap'
const styles = require('./index.less')

interface IFAQState {
  faqOpenState: object
  faqData: IFAQData[]
}

interface IFAQ {
  id?: string
  question: string
  answer: JSX.Element
}

interface IFAQData {
  sectionDescription: string
  faqs: IFAQ[]
}

class FAQ extends Container<{}, IFAQState> {
  state = {
    faqOpenState: {},
    faqData: [
      {
        sectionDescription: 'What Does FoundationMark Do?',
        faqs: [
          {
            question: 'FoundationMark Enables Private Foundations To Benchmark Their Investment Performance Against Other Foundations',
            answer: (
              <div>
                <ul>
                  <li>FoundationMark estimates the investment performance of over 40,000 foundation.  We use this data to construct the most comprehensive indices available.</li>
                  <li>FoundationMark provides trustees with free independent assessments of their performance versus the foundation universe, public markets, and peer foundations.</li>
                </ul>
              </div>
            )
          }
        ]
      },
      {
        sectionDescription: 'Foundation Overview',
        faqs: [
          {
            question: 'What Are Portfolio Foundations?',
            answer: (
              <div>
                <p>FoundationMark uses the term “Portfolio Foundations” to describe foundations that reported 95% or more of their assets are specifically denoted as “investments” in their public filings.</p>
              </div>
            )
          },
          {
            question: 'What Is The FoundationMark Universe? How Many Foundations Does FoundationMark Track?',
            answer: (
              <div>
                <p>FoundationMark collects information on all nonprofits that file as Private Foundations with the IRS.  Those foundations with assets over $1 million are included in the FoundationMark Universe.  There are over 40,000 foundations in the FoundationMark Universe, whose assets represent collectively over 97% of total foundation assets.  The investment performance of the constituents of the FoundationMark Universe form the basis for constructing the FoundationMark Indices and associated financial metrics.</p>
                <p><a href="#/resources?state=true">Click</a> to see which foundations are included in the FoundationMark Universe.</p>
              </div>
            )
          }
        ]
      },
      {
        sectionDescription: 'Measuring Performance',
        faqs: [
          {
            id: 'performanceMatters',
            question: 'How Does FoundationMark Estimate Performance?',
            answer: (
              <div>
                <p>Investment returns are defined as the change in value of an investment over time. While foundations are not required to report their investment performance, they are, however, required to file a tax form with the IRS each year containing the 4 essential inputs (1) beginning value, 2) ending value, 3) cash flow over the period, and 4) a distinct time period - their fiscal year) necessary to estimate investment performance.</p>
                <h5>The FoundationMark Method</h5>
                <p>The core concept behind the FoundationMark methodology is best illustrated with an example. Consider the scenario represented below in which a foundation begins a year with $20 million in total assets ($19.5 million in net assets after adjusting for $500,000 in liabilities) that increases in value to $21 million in total ($20.7 million, net) by the end of the year after receiving $600,000 in incoming contributions, distributing $1.6 million to charity, and incurring $200,000 in operating expenses. As seen in the calculation below, this would imply a 12% return. The patent pending FoundationMark methodology expands on this core concept by accounting for disclosed investment expenses, asset composition, and timing of cash flows.</p>
                <div className={styles.faqImageContainer}>
                  <img src="/assets/img/FoundationMarkMethod.jpg" alt="Method and Scatter Pie" style={{ width: '100%' }} />
                </div>
                <p>Calculating performance estimates using the FoundationMark method ensures consistency and transparency across the foundation universe for comparative purposes.</p>
              </div>
            )
          },
          {
            question: 'Measuring Performance: Indices – The Foundation Market',
            answer: (
              <div>
                <p>The FoundationMark Indices are constructed using the median return of the population of foundations that qualify for inclusion in the indices.  FoundationMark’s primary concern is providing meaningful representative measures of investment performance; therefore, foundations whose performance calculation might be influenced by non-investment factors are exclude from the indices.</p>
                <p>Factors for exclusion include:
                  <ul>
                    <li>Change in fiscal period.</li>
                    <li>Less than 95% of assets designated as investments.</li>
                    <li>High levels of contribution or grants as a percent of assets.</li>
                    <li>Significant non-investment income.</li>
                  </ul>
                </p>
                <p>Overall about 90% qualify for inclusion in the indices.</p>
              </div>
            )
          },
          {
            id: 'fatTail',
            question: 'Distribution Of Returns: The “Fat Tail” Distribution',
            answer: (
              <div>
                <p>FoundationMark has observed a consistent pattern of return distributions that exhibit a typical “normal”  distribution around the median, but with significant “fat-tail” skewness at both the upper and lower ends, likely due to “single stock” portfolios or concentrated positions.</p>
                <div className={styles.faqImageContainer}>
                  <h4 className="text-center">Median</h4>
                  <img src="/assets/img/fat_tail_image.png" alt="Fat Tail" style={{ width: '100%' }} />
                </div>
              </div>
            )
          },
          {
            id: 'starRating',
            question: 'Star Ratings: What are they?',
            answer: (
              <section>
                <Row>
                  <Col md={6}>
                    <section id="getAway">
                      <ul style={{ paddingTop: '0' }}>
                        <li style={{ fontSize: '15px' }}>FoundationMark Rates private foundations from 5 (best) stars to 1 star based on their estimated investment performance in comparison to the overall foundation universe.</li>
                        <li style={{ fontSize: '15px' }}>The top 20% of foundations receive 5 stars and the bottom 20% receive 1 star.</li>
                        <li style={{ fontSize: '15px' }}>Foundations are rated for one-, three- and five-year periods.</li>
                        <li style={{ fontSize: '15px' }}>Additionally, FoundationMark rates performance by observed portfolio strategy, please contact us for more information.</li>
                      </ul></section>
                  </Col>
                  <Col md={6} style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '2.5vw', color: '#333', lineHeight: '1.0em' }}>
                      <h4 style={{ marginTop: '0' }}>Star Ratings</h4>
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                    </div>
                    <div style={{ fontSize: '2.5vw', color: '#333', lineHeight: '1.0em' }}>
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                    </div>
                    <div style={{ fontSize: '2.5vw', color: '#333', lineHeight: '1.0em' }}>
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                    </div>
                    <div style={{ fontSize: '2.5vw', color: '#333', lineHeight: '1.0em' }}>
                      <i className="fa fa-fw fa-star-o" />
                      <i className="fa fa-fw fa-star-o" />
                    </div>
                    <div style={{ fontSize: '2.5vw', color: '#333', lineHeight: '1.0em' }}>
                      <i className="fa fa-fw fa-star-o" />
                    </div>
                  </Col>
                </Row>
              </section>
            )
          }
        ]
      },
      {
        sectionDescription: 'About The Indices',
        faqs: [
          {
            id: 'aboutIndices',
            question: 'Why Isn’t There Just One FoundationMark Index? Why Are There 12?',
            answer: (
              <div>
                <p>Foundations may elect any month end as their fiscal year end, so for example a foundation with a September 30th fiscal year end’s tax filing would cover the period from October 1st to September 30th of the following calendar year. FoundationMark has separate indices for each month to account for the different fiscal periods. Over 75% of foundations use the calendar year as their fiscal period and have a December 31st year end.</p>
                <div className={styles.faqImageContainer}>
                  <img src="/assets/img/Month-End.jpg" alt="Month End" style={{ width: '100%' }} />
                </div>
                <p>For the purposes of assigning fiscal years, FoundationMark categorizes foundations with fiscal year ends June-December to be the same at the calendar year, for example, the year 2016 would refer to the period ending June 30, 2016 for a foundation with a June fiscal year. For foundations with January – May fiscal end periods, the fiscal year is categorized by the period that included the most months.  For example, for a March fiscal foundation, the 2016 year would end on March 31st 2017, as it reflects 9 months in 2016 and just 3 in 2017.</p>
              </div>
            )
          },
          {
            question: 'How Often Are The FoundationMark Indices Updated?',
            answer: (
              <div>
                <p>FoundationMark updates the indices as well as other financial metrics monthly on a rolling basis as new public filings are released.</p>
                <div className={styles.faqImageContainer}>
                  <img src="/assets/img/ReportingCalendar.jpg" alt="Calendar" style={{ width: '100%' }} />
                </div>
              </div>
            )
          },
          {
            question: 'Is Quarterly Or Monthly Data Available',
            answer: (
              <div>
                <p>Foundations are only required to file annually with the IRS, so no quarterly or monthly returns can be calculated.</p>
              </div>
            )
          }
        ]
      },
      {
        sectionDescription: 'Peer Groups',
        faqs: [
          {
            id: 'indicesAndPeerGroups',
            question: 'Why Does FoundationMark Construct Peer Groups? How Does FoundationMark Assign Peer Groups?',
            answer: (
              <div>
                <p>FoundationMark believes that peer group analysis is a valuable tool for foundations to examine their performance on a more granular level than by comparison to indices alone.  FoundationMark categorize foundations by 1) asset size, and 2) portfolio positioning.</p>
              </div>
            )
          },
          {
            question: 'Why Delineate By Asset Level?',
            answer: (
              <div>
                <p>The investment opportunity set can can be limited by asset size. For example, private equity and real estate funds typically require high minimum investments, effectively excluding smaller foundations from participating in those asset classes.</p>
                <p>Investment expenses can vary by asset size, so having a representative peer group based on asset level is often a better barometer than a comparison to a broader group.
                </p>
              </div>
            )
          },
          {
            id: 'portfolioStrategy',
            question: 'Why Delineate By Portfolio Strategy?',
            answer: (
              <div>
                <p>Asset allocation represents a strategic decision that foundations make in pursuing their investment objectives</p>
                <p>A core tenet of investing is the relationship between risk and reward - investments with greater potential reward are associated with higher risk.  </p>
                <p>Based on asset allocation, FoundationMark has categorized foundations into 4 core portfolio strategies:
                <ul>
                    <li>Capital Appreciation</li>
                    <li>Balanced </li>
                    <li>Investments&nbsp;&#45;&nbsp;Other&#42;</li>
                    <li>Capital Preservation</li>
                  </ul>
                </p>
                <div className={styles.faqImageContainer}>
                  <img src="/assets/img/portfoluio_strategies.png" alt="Asset Levels" style={{ width: '100%' }} />
                </div>
                <p>Investments&nbsp;&#45;&nbsp;Others&#42;: There is a distinct line on the IRS form requiring the fair market value of a foundation’s holdings in 'Investments&nbsp;&#45;&nbsp;Other', which may include hedge funds, private equity, commodities, and other investments. Foundations with over 60% of their assets in 'Investments – Other' are classified by portfolio strategy with asset class name. </p>
              </div>
            )
          }
        ]
      },
      {
        sectionDescription: 'Reports',
        faqs: [
          {
            question: 'What Are FoundationMark Performance Reports?',
            answer: (
              <p>Performance reports provide foundations with individualized accounts describing their estimated performance on an absolute basis as well as in relation to public market barometers, the foundation market, and peer groups. In addition, FoundationMark provides data on each foundation’s operating and administrative expenses in comparison to peers. </p>
            )
          },
          {
            question: 'Can Anyone Request A FoundationMark Report?',
            answer: (
              <p>Each FoundationMark report is created specifically for the exclusive use of that foundation’s trustees and officers. Verification may be required.</p>
            )
          },
          {
            question: 'How Much Does A FoundationMark Report Cost?',
            answer: (
              <p>FoundationMark provides reports to trustees and officers at no charge.</p>
            )
          }
        ]
      }
    ]
  }

  componentDidMount() {
    const locationSearch = this.getLocationSearch()

    if ('id' in locationSearch) {
      const questionID = locationSearch.id

      //Scroll to question if in location search
      this.state.faqData.every((faqDataElem) => {
        return faqDataElem.faqs.every((faq: IFAQ) => {
          if (faq.id === questionID) {
            this.toggleOpenStateFor(faq.question, () => {
              document.getElementById(faq.id).scrollIntoView()
            })

            return false
          }

          return true
        })
      })
    }
  }

  mapAppStateToContainerState(appState: IAppState): IFAQState {
    return this.state
  }

  toggleOpenStateFor(question: string, callback?: () => void) {
    const faqOpenState = this.state.faqOpenState

    if (question in faqOpenState) {
      faqOpenState[question] = !faqOpenState[question]
    } else {
      faqOpenState[question] = true
    }

    this.setState({ faqOpenState }, callback)
  }

  render() {
    return (
      <section className="padding-top-lg">
        <div className="container" style={{ overflowX: 'hidden' }}>
          <div className="jumbotron animated fadeIn">
            <h1 className="hidden-xs">Frequently Asked Questions</h1>
            <h3 className="visible-xs">FAQs</h3>
          </div>
          <div className="animated fadeIn">
            <Row>
              <Col md={10} lg={8}>
                {this.state.faqData.map((faqData) => (
                  <article className="margin-y-lg" key={faqData.sectionDescription}>
                    <h3>{faqData.sectionDescription}</h3>

                    {faqData.faqs.map((faq: IFAQ) => (
                      <div className="panel panel-info" key={faq.question} id={faq.id}>
                        <div className={`panel-heading clearfix ${styles.panelHeading}`}
                          onClick={() => this.toggleOpenStateFor(faq.question)}>
                          <i className={`${styles.collapseIcon} fa fa-fw fa-chevron-${this.state.faqOpenState[faq.question] ? 'down' : 'right'}`} />
                          {faq.question}
                        </div>
                        <Collapse in={this.state.faqOpenState[faq.question]}>
                          <div className={`panel-body`}>
                            {faq.answer}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </article>
                ))}
              </Col>
            </Row>
          </div>
        </div>

        <ContactUs />
        <CopyrightFooter />
      </section>
    )
  }
}

export {
  FAQ
}



// WEBPACK FOOTER //
// ./src/app/containers/FAQ/index.tsx